/* eslint-disable array-callback-return */
import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';

import { takeLatest, call, put } from 'redux-saga/effects';
import * as projectApi from '../../lib/api/project';
import uuid from 'react-uuid';
import { finishLoading, startLoading } from '../loading';
import _ from 'lodash';
import dayjs from 'dayjs';

//최초 등록시 data 로드
const [INIT_ORDER, INIT_ORDER_SUCCESS, INIT_ORDER_FAILURE] =
  createRequestActionTypes('orderAdd/INIT_ORDER');
export const initOrder = createAction(INIT_ORDER, (chance) => chance);

//계약서 분할 변경
const SET_BILLINVLIST = 'orderAdd/SET_BILLINVLIST';
export const setBillInvList = createAction(SET_BILLINVLIST, (data) => data);

const SET_CONFIRMBILLS = 'orderAdd/SET_CONFIRMBILLS';
export const setConfirmBills = createAction(
  SET_CONFIRMBILLS,
  (confirmBills) => confirmBills,
);

const UNLOAD_ORDERADD = 'orderAdd/UNLOAD_ORDERADD';
export const unloadOrderAdd = createAction(UNLOAD_ORDERADD);

const [
  VIEW_ORDER_LETTER,
  VIEW_ORDER_LETTER_SUCCESS,
  VIEW_ORDER_LETTER_FAILURE,
] = createRequestActionTypes('orderAdd/VIEW_ORDER_LETTER');
export const viewOrderLetter = createAction(VIEW_ORDER_LETTER, (id) => id);
const viewOrderLetterSaga = createRequestSaga(
  VIEW_ORDER_LETTER,
  projectApi.getOrderInfoAll,
);

const UNLOAD_ORDER_LETTER = 'orderAdd/UNLOAD_ORDER_LETTER';
export const unloadOrderLetter = createAction(UNLOAD_ORDER_LETTER);

const SET_ORDER_LETTER = 'orderAdd/SET_ORDER_LETTER';
export const setOrderLetter = createAction(SET_ORDER_LETTER, (order) => order);

function* initOrderSaga(action) {
  yield put(startLoading(INIT_ORDER));

  const roUuid = uuid(); //수주번호 생성함.
  const chance = action.payload;

  try {

    // to day 

    if( chance?.mtnFreeSt != null ) {

    }
    
    //초기 receiveOrderInfo 정보 구성함.
    const receiveOrderInf = {
      roUuid: roUuid,
      prjUuid: chance.prjUuid,
      prjNo: chance.prjNo,
      cstNm: chance.cstNm,
      partnerUuid: chance.vendorCmp, //매출처
      partnerNm: chance.vendorCmpNm, //매출처
      employeeUuid: chance.vendorEmp, //매출처 담당자
      employeeNm: chance.vendorEmpNm, //매출처 담당자
      partnerInc: chance.partnerInc,
      chargeNm: chance.chargeNm,
      salesUuid: chance.crtUsr, //영업담당자? 확인
      salesNm: chance.pmNm,
      siDt: chance.expDay,
      expDay: new Date(),
      dlvryDuedate: dayjs(chance?.expDay).format('YYYY-MM-DD'),

      mtnFreeTm: chance?.mtnFreeTor,
      mtnFreeStrtDt: chance?.mtnFreeSt,
      mtnFreeEndDt: chance?.mtnFreeEd,
      licStrtDt: dayjs(chance?.expDay).format('YYYY-MM-DD'),
      licEndDt:  dayjs(chance?.expDay).add(12, 'month').endOf('month').format('YYYY-MM-DD'),
    };

    if( receiveOrderInf.mtnFreeStrtDt == null ) receiveOrderInf.mtnFreeStrtDt = receiveOrderInf.licStrtDt; 
    if( receiveOrderInf.mtnFreeEndDt == null ) receiveOrderInf.mtnFreeEndDt = receiveOrderInf.licEndDt;

    // formik.setFieldValue('licStrtDt', dayjs().format('YYYY-MM-DD'));
    // formik.setFieldValue('licEndDt', dayjs().add(12, 'month').endOf('month').format('YYYY-MM-DD'));

    //초기 billInfList 정보 구성함
    const initBillRes = yield call(projectApi.getInitPayments, chance.prjUuid);

    let billInfList = [];
    let salesDetails = [];
    let purchaseDetails = [];

    if (initBillRes.data.list) {
      salesDetails = initBillRes.data.list.filter(
        (inv) => inv.billTyp === '매출',
      );
      purchaseDetails = initBillRes.data.list.filter(
        (inv) => inv.billTyp === '매입',
      );
    }

    if (initBillRes.data) {
      initBillRes.data.list.map((inf) => {
        let billUuid = uuid();
        let billInf = {
          id: billUuid,
          billUuid: billUuid,
          prjUuid: chance.prjUuid,
          roUuid: roUuid,
          billTyp: inf.billTyp,
          partnerUuid: inf.partnerUuid,
          partnerNm: inf.partnerNm,
          billDiv: 1,
          billAmt: Number(inf.billAmt), //계산서금액
          issueReq: inf.issueReq, //발행요청금액
          issueComp: inf.issueComp, //발행완료금액
          collComp: inf.collComp, //수금금액
          billYn: 'Y', //사용유무
        };
        billInfList.push(billInf);
      });
    }

    let billInvList = [];
    if (billInfList.length > 0) {
      _.forEach(billInfList, (inf) => {
        //let today = dayjs(new Date()).format('YYYY-MM-DD');
        let invUuid = uuid();
        let billInv = {
          id: invUuid,
          invUuid: invUuid,
          roUuid: inf.roUuid,
          billUuid: inf.billUuid,
          prjUuid: inf.prjUuid,
          invNo: invUuid,
          invYn: 'N',
          billTyp: inf?.billTyp,
          partnerNm: inf?.partnerNm,
          invAmt: Number(inf.billAmt),
          reqPlanDt: null, //발행예정일
          reqPlanYn: 'N',
          reqPlanTxt: null,
          reqCompDt: null, //발행완료일
          reqCompYn: 'N',
          reqCompTxt: null,
          procPlanDt: null, //지급(수금) 예정 일자
          procPlanYn: 'N',
          procCompDt: null, //지급(수금)  일자
          procCompYn: 'N',
          rsltCompDt: null, //실적확정일
          rsltCompYn: 'N',
        };

        billInvList.push(billInv);
      });
    }

    yield put({
      type: INIT_ORDER_SUCCESS,
      payload: {
        receiveOrderInf: receiveOrderInf,
        billInfList: billInfList,
        salesDetails: salesDetails,
        purchaseDetails: purchaseDetails,
        billInvList: billInvList,
      },
    });
  } catch (e) {
    yield put({
      type: INIT_ORDER_FAILURE,
      payload: e,
      error: true,
    });
  }
  yield put(finishLoading(INIT_ORDER));
}

const initialState = {
  confirmBills: false,
  apprUuid: null,
  receiveOrderInf: null,
  billInfList: null,
  salesDetails: null,
  purchaseDetails: null,
  billInvList: null,
  approvalList: null,
  // 결재 V2 이관(2026-10-20) - cngOrderMainInf V2 분기 포팅: getOrderMainInf가
  // 돌려주는 apprDocV2(진행중/완료 V2 결재 문서, 없으면 null)를 담는다. V1
  // approvalList는 V2로 상신된 건이면 항상 빈 배열이라 "V1/V2 구분"에는 못 쓴다.
  apprDocV2: null,
  message: null,
  error: null,
};

export function* orderAddSaga() {
  yield takeLatest(INIT_ORDER, initOrderSaga);
  yield takeLatest(VIEW_ORDER_LETTER, viewOrderLetterSaga);
}

const orderAdd = handleActions(
  {
    [INIT_ORDER_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      receiveOrderInf: data.receiveOrderInf,
      billInfList: data.billInfList,
      billInvList: data.billInvList,
      salesDetails: data.salesDetails,
      purchaseDetails: data.purchaseDetails,
    }),
    [INIT_ORDER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      receiveOrderInf: null,
      billInfList: null,
      billInvList: null,
      salesDetails: null,
      purchaseDetails: null,
      error: error,
    }),
    [SET_BILLINVLIST]: (state, { payload: billInvList }) => ({
      ...state,
      billInvList: billInvList,
    }),
    [SET_CONFIRMBILLS]: (state, { payload: confirm }) => ({
      ...state,
      confirmBills: confirm,
    }),
    [VIEW_ORDER_LETTER_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      apprUuid: data.apprUuid,
      receiveOrderInf: data.receiveOrderInf,
      billInfList: data.billInfList.map((inf) => ({
        id: inf.billUuid,
        billUuid: inf.billUuid,
        prjUuid: inf.prjUuid,
        roUuid: inf.roUuid,
        billDiv: 1,
        partnerUuid: inf.partnerUuid,
        partnerNm: inf.partnerNm,
        billAmt: Number(inf.billAmt),
        billTyp: inf.billTyp,
        issueReq: inf.issueReq,
        issueComp: inf.issueComp,
        collComp: inf.collComp,
        billYn: inf.billYn,
        crtUsr: inf.crtUsr,
        crtNm: inf.crtNm,
        crtDt: inf.crtDt,
        cngUsr: inf.cngUsr,
        cngNm: inf.cngNm,
        cngDt: inf.cngDt,
      })),
      salesDetails: data.billInfList.filter((inf) => inf.billTyp === '매출'),
      purchaseDetails: data.billInfList.filter((inf) => inf.billTyp === '매입'),
      billInvList: data.billInvList.map((inv) => ({
        id: inv.invUuid,
        invUuid: inv.invUuid,
        prjUuid: inv.prjUuid,
        roUuid: inv.roUuid,
        billUuid: inv.billUuid,
        billTyp: inv.billTyp,
        partnerNm: inv?.partnerNm,
        invTyp: inv.intTyp,
        invNo: inv.invNo,
        invYn: inv.invYn,
        invAmt: Number(inv.invAmt),
        reqPlanDt: inv.reqPlanDt,
        reqPlanUsr: inv.reqPlanUsr,
        reqPlanTxt: inv.reqPlanTxt,
        reqPlanYn: inv.reqPlanYn,
        reqCompDt: inv.reqCompDt,
        reqCompYn: inv.reqCompYn,
        reqCompUsr: inv.reqCompUsr,
        reqCompTxt: inv.reqCompTxt,
        procPlanDt: inv.procPlanDt,
        procPlanYn: inv.procPlanYn,
        procPlanUsr: inv.procPlanUsr,
        procCompDt: inv.procCompDt,
        procCompYn: inv.procCompYn,
        procTyp: inv.procTyp,
        rsltCompDt: inv.rsltCompDt,
        rsltCompYn: inv.rsltCompYn,
        crtUsr: inv.crtUsr,
        crtNm: inv.crtNm,
        crtDt: inv.crtDt,
        cngUsr: inv.cngUsr,
        cngNm: inv.cngNm,
        cngDt: inv.cngDt,
      })),
      approvalList: data.approvalList.map((doc) => ({
        id: doc.docuUuid,
        apprUuid: doc.apprUuid,
        docuUuid: doc.docuUuid,
        docyTyp: doc.docyTyp,
        docuStep: doc.docuStep,
        docuUsr: doc.docuUsr,
        docuUsrNm: doc.docuUsrNm,
        docuUsrProfile: doc.docuUsrProfile,
        docuUsrDptNm: doc.docuUsrDptNm,
        docuUsrGradeNm: doc.docuUsrGradeNm,
        docuYn: doc.docuYn,
        docuDt: doc.docuDt,
        docuTxt: doc.docuTxt,
        docuCd: doc.docuCd,
        crtUsr: doc.crtUsr,
        crtDt: doc.crtDt,
        cngUsr: doc.cngUsr,
        cngDt: doc.cngDt,
      })),
      apprDocV2: data.apprDocV2 || null,
      message: data.message,
    }),
    [VIEW_ORDER_LETTER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),

    [SET_ORDER_LETTER]: (state, { payload: data }) => ({
      ...state,
      apprUuid: data.apprUuid,
      receiveOrderInf: data.receiveOrderInf,
      billInfList: data.billInfList.map((inf) => ({
        id: inf.billUuid,
        billUuid: inf.billUuid,
        prjUuid: inf.prjUuid,
        roUuid: inf.roUuid,
        billDiv: 1,
        partnerUuid: inf.partnerUuid,
        partnerNm: inf.partnerNm,
        billAmt: Number(inf.billAmt),
        billTyp: inf.billTyp,
        issueReq: inf.issueReq,
        issueComp: inf.issueComp,
        collComp: inf.collComp,
        billYn: inf.billYn,
        crtUsr: inf.crtUsr,
        crtNm: inf.crtNm,
        crtDt: inf.crtDt,
        cngUsr: inf.cngUsr,
        cngNm: inf.cngNm,
        cngDt: inf.cngDt,
      })),
      billInvList: data.billInvList.map((inv) => ({
        id: inv.invUuid,
        invUuid: inv.invUuid,
        prjUuid: inv.prjUuid,
        roUuid: inv.roUuid,
        billUuid: inv.billUuid,
        invNo: inv.invNo,
        invYn: inv.invYn,
        invAmt: Number(inv.invAmt),
        reqPlanDt: inv.reqPlanDt,
        reqPlanUsr: inv.reqPlanUsr,
        reqPlanTxt: inv.reqPlanTxt,
        reqPlanYn: inv.reqPlanYn,
        reqCompDt: inv.reqCompDt,
        reqCompYn: inv.reqCompYn,
        reqCompUsr: inv.reqCompUsr,
        reqCompTxt: inv.reqCompTxt,
        procPlanDt: inv.procPlanDt,
        procPlanYn: inv.procPlanYn,
        procPlanUsr: inv.procPlanUsr,
        procCompDt: inv.procCompDt,
        procCompYn: inv.procCompYn,
        procTyp: inv.procTyp,
        rsltCompDt: inv.rsltCompDt,
        rsltCompYn: inv.rsltCompYn,
        crtUsr: inv.crtUsr,
        crtNm: inv.crtNm,
        crtDt: inv.crtDt,
        cngUsr: inv.cngUsr,
        cngNm: inv.cngNm,
        cngDt: inv.cngDt,
      })),
      approvalList: data.approvalList.map((doc) => ({
        id: doc.docuUuid,
        apprUuid: doc.apprUuid,
        docuUuid: doc.docuUuid,
        docyTyp: doc.docyTyp,
        docuStep: doc.docuStep,
        docuUsr: doc.docuUsr,
        docuUsrNm: doc.docuUsrNm,
        docuUsrProfile: doc.docuUsrProfile,
        docuUsrDptNm: doc.docuUsrDptNm,
        docuUsrGradeNm: doc.docuUsrGradeNm,
        docuYn: doc.docuYn,
        docuDt: doc.docuDt,
        docuTxt: doc.docuTxt,
        docuCd: doc.docuCd,
        crtUsr: doc.crtUsr,
        crtDt: doc.crtDt,
        cngUsr: doc.cngUsr,
        cngDt: doc.cngDt,
      })),
      apprDocV2: data.apprDocV2 || null,
    }),
    [UNLOAD_ORDER_LETTER]: () => initialState,
    [UNLOAD_ORDERADD]: () => initialState,
  },
  initialState,
);
export default orderAdd;
